
import * as React from "react";


import './App.css';
import './styles.css';
import Register from "./pages/register/Register";
import LoginClient from './pages/login-client/Login';


import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomepageCons from "./pages/homepage-cons/Homepage-cons";
import CreateClient from "./pages/CreateClient/CreateClient";
import LogIn from "./pages/loginDesignTest/LoginDesign";
import DocTemplate from "./pages/docTemplates/DocTemplate";
import ClientProfile from "./pages/clientProfile/ClientProfile";

import TemplateList from "./pages/templateList/templateList";

import ViewTemplate from "./pages/viewTemplate/viewTemplate";
import AnnexeA from "./pages/AnnexeA/AnnexeA"
import ClientUploadDoc from "./pages/ClientUploadDoc/clientUploadDoc";
import FillForm from "./pages/FillForm/FillForm";
import PasswordForgotten from "./pages/passwordForgotten/PasswordForgotten";
import PasswordReset from "./pages/passwordReset/ResetPasword";
import StripeCheckOut from "./pages/stripeCheckout/stripeCheckout";
import Settings from "./pages/settings/Setting";
import ErrorPage from "./pages/Error/error";
import AskForUpgrade from "./pages/askForUpgrade/askForUpgrade";
import Support from "./pages/Support/support";
import Layout from "./pages/Layout";
import DocumentViewer from "./pages/docViewer/docViewer";
import ArchivedClients from "./pages/ArchivedClients/archivedClients"
import CompleteFiles from "./pages/completeFiles/CompleteFiles";
import LateFiles from "./pages/lateFiles/LateFiles";
import CollectingFiles from "./pages/collectingFiles/CollectingFiles";
import Clients from "./pages/clients/clients";
import Homepage from "./pages/home/home";
import LandingPage from "./pages/LandingPage/LandingPage";
import TermsOfService from "./pages/TermsOfService/TermsOfService";

import PaymentSuccess from "./pages/paymentSuccess/PaymentSuccess";

function App() {
  return (
    <Router>
      <Routes>
        {/* --- PUBLIC ROUTES --- */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LogIn />} />
        <Route path="/register" element={<Register />} />
        <Route path="/my-account" element={<LoginClient />} />
        <Route path="/passwordForgotten" element={<PasswordForgotten />} />
        <Route path="/passwordReset/:token" element={<PasswordReset />} />
        <Route path="/error404" element={<ErrorPage />} />
        <Route path="/terms" element={<TermsOfService />} />
    

        {/* --- CONSULTANT DASHBOARD (Protected by Layout) --- */}
        {/* All these routes will start with /dashboard/... */}
        <Route path="/dashboard" element={<Layout />}>
          
          {/* Main Home */}
          <Route index element={<HomepageCons />} /> 

          {/* Client Management */}
          {/* NOTICE: I removed :id. The auth cookie tells the DB who you are. */}
          <Route path="clients" element={<Clients />} /> 
          <Route path="collecting" element={<CollectingFiles />} />
          <Route path="completed" element={<CompleteFiles />} />
          <Route path="late" element={<LateFiles />} /> 
          <Route path="new-client" element={<CreateClient />} />
          <Route path="archive" element={<ArchivedClients />} />
          
          {/* Specific Client Profile */}
          {/* This matches the link we made: <Link to={`/dashboard/client/${id}`}> */}
          <Route path="client/:id" element={<ClientProfile />} /> 

          {/* Templates */}
          <Route path="templates" element={<TemplateList />} />
          <Route path="new-template" element={<DocTemplate />} />
          <Route path="templates/:id" element={<ViewTemplate />} />

          {/* Settings & Support */}
          {/* Removed :id here too. Settings loads "my" settings. */}
          <Route path="settings" element={<Settings />} /> 
          <Route path="support" element={<Support />} />
        </Route>

        {/* --- CLIENT PORTAL ROUTES --- */}
        <Route path="/upload/:id" element={<ClientUploadDoc />} />
        <Route path="/upload/:id/form/:formId" element={<FillForm />} />

        {/* --- UTILITIES --- */}
        <Route path="/view-document" element={<DocumentViewer />} />
        <Route path="/checkout" element={<StripeCheckOut />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        
        {/* Fallback */}
      {/*   <Route path="*" element={<Navigate to="/error404" replace />} /> */}

      </Routes>
    </Router>
  );
}

export default App;